import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { languageApi } from "src/services/Base/LanguageApi";
import { parametersApi } from "src/services/Base/ParametersApi";

export interface IParametersKeyValue {
  id?: number,
  key?: number,
  value?: string,
  siraNo?: number,
  grupId?: number,
  aktif?: string,
  alan01?: string;
  trValue?: string;
  sablonId?:number;
}
interface IParametersState {
  data: Array<IParametersKeyValue>
}

const ParametersSlice = createSlice<IParametersState, MapReducerPayloads<IParametersState, {
  setState: IParametersState
}>>({
  name: 'ParametersSlice',
  initialState: {
    data: new Array<IParametersKeyValue>()
  },
  reducers: {
    setState: (state, action) => action.payload
  },
  extraReducers: (builder) => {
    builder.addMatcher(parametersApi.endpoints.getAllParameters.matchFulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload.map(pay => {
          return {
            id: pay.id,
            aktif: pay.aktif,
            grupId: pay.grupId,
            key: pay.kodu,
            value: pay.adi,
            siraNo: pay.sirano,
            alan01: pay.alan01,
            trValue: pay.adi,
            sablonId:pay.sablonId
          }
        })
      }
    })
    builder.addMatcher(languageApi.endpoints.getLanguageByNamespace.matchFulfilled, (state, action) => {
      return {
        data: state.data.map(m => {
          let val = m.value;
          let filter = action.payload.find(f => f.label === m.grupId + "|" + m.key);
          if (filter)
            val = filter.degerKarsiligi ? filter.degerKarsiligi : filter.deger
          return {
            ...m,
            value: val
          }
        })
      }
    })
  }
})
export default ParametersSlice;